import { render, staticRenderFns } from "./DividerBlock.vue?vue&type=template&id=5df1c45c&"
import script from "./DividerBlock.vue?vue&type=script&lang=js&"
export * from "./DividerBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports